import { useEffect, useState } from 'react'
import StoreProductCard from './StoreProductCard'

export default function ProductBubble({ product, visible, onBuy }) {
  const [mounted, setMounted] = useState(false)
  const [exiting, setExiting] = useState(false)
  const [hovered, setHovered] = useState(false)

  useEffect(() => {
    if (visible && !mounted) {
      setExiting(false)
      setMounted(true)
    }
    if (!visible && mounted) {
      setExiting(true)
      const t = setTimeout(() => {
        setMounted(false)
        setExiting(false)
      }, 280)
      return () => clearTimeout(t)
    }
  }, [visible])

  if (!mounted) return null

  const containerStyle = {
    flex: '1 1 200px',
    minWidth: 0,
    transition: 'opacity 0.28s ease, transform 0.28s ease, box-shadow 0.15s ease',
    opacity: exiting ? 0 : 1,
    transform: exiting ? 'translateY(8px)' : hovered ? 'translateY(-1px)' : 'translateY(0)',
    animation: !exiting ? 'aa-bubble-in 0.28s ease forwards' : undefined,
    cursor: 'pointer',
    borderRadius: 14,
    background: hovered ? '#0ea572' : '#10b981',
    boxShadow: hovered
      ? '0 6px 20px rgba(16,185,129,0.45)'
      : '0 3px 12px rgba(16,185,129,0.3)',
  }

  return (
    <>
      <style>{`
        @keyframes aa-bubble-in {
          from { opacity: 0; transform: translateY(10px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <div
        style={containerStyle}
        onClick={() => onBuy?.(product.pid)}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <StoreProductCard {...product} inverted />
      </div>
    </>
  )
}
